/**
 * Home page that immediately redirects authenticated users to the dashboard.
 *
 * @module pages/Home
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */
import React from "react";
import { Redirect } from "react-router-dom";

/**
 * Home page component. Renders a redirect to /dashboard on mount.
 *
 * @component
 * @returns {JSX.Element} A Redirect to /dashboard.
 */
const Home = () => (
  <div>
    <Redirect to="/dashboard" />
  </div>
);

export default Home;
